<template>
  <a-drawer
    :title="title"
    :width="width"
    placement="right"
    :closable="false"
    @close="close"
    :visible="visible">
  
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="订单编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['orderCode']" placeholder="请输入订单编号"></a-input>
        </a-form-item>
        <a-form-item label="渠道订单编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['channelOrderCode']" placeholder="请输入渠道订单编号"></a-input>
        </a-form-item>
        <a-form-item label="是否配送" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['isDelivery']" :trigger-change="true" dictCode="yesorno" placeholder="请选择是否配送"/>
        </a-form-item>
        <a-form-item label="收货地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['deliveryAddress']" placeholder="请输入收货地址"></a-input>
        </a-form-item>
        <a-form-item label="客户姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['consumerName']" placeholder="请输入客户姓名"></a-input>
        </a-form-item>
        <a-form-item label="客户手机" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['consumerPhone']" placeholder="请输入客户手机"></a-input>
        </a-form-item>
        <a-form-item label="下单时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-date placeholder="请选择下单时间" v-decorator="['orderCreatetime']" :trigger-change="true" :show-time="true" date-format="YYYY-MM-DD HH:mm:ss" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="付款时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-date placeholder="请选择付款时间" v-decorator="['orderPaytime']" :trigger-change="true" :show-time="true" date-format="YYYY-MM-DD HH:mm:ss" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="订单实付金额" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="['orderTotalprice']" placeholder="请输入订单实付金额" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="订单原价" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="['orderOriginalprice']" placeholder="请输入订单原价" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="订单用户价格" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="['orderUserprice']" placeholder="请输入订单用户价格" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="订单配送费用" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="['orderDeliveryprice']" placeholder="请输入订单配送费用" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="是否打折" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="['isOnsale']" placeholder="请输入是否打折" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="折扣" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="['salePrice']" placeholder="请输入折扣" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="折扣说明" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['saleContext']" placeholder="请输入折扣说明"></a-input>
        </a-form-item>
        <a-form-item label="是否使用优惠券" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="['isCoupon']" placeholder="请输入是否使用优惠券" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="优惠券抵扣" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="['couponPrice']" placeholder="请输入优惠券抵扣" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="优惠券名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['couponName']" placeholder="请输入优惠券名称"></a-input>
        </a-form-item>
        <a-form-item label="订单所属门店" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['orderStoreid']" :trigger-change="true" dictCode="sales_physical_store,phystore_name,id" placeholder="请选择订单所属门店"/>
        </a-form-item>
        <a-form-item label="门店联系方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['orderStorecontact']" placeholder="请输入门店联系方式"></a-input>
        </a-form-item>
        <a-form-item label="门店负责人" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['orderStoreowner']" placeholder="请输入门店负责人"></a-input>
        </a-form-item>
        <a-form-item label="订单状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['orderState']" :trigger-change="true" dictCode="s_order_state" placeholder="请选择订单状态"/>
        </a-form-item>
        <a-form-item label="购买商品列表" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea v-decorator="['relPublishids']" rows="4" placeholder="请输入购买商品列表"/>
        </a-form-item>
        <a-form-item label="订单渠道" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['orderChanner']" :trigger-change="true" dictCode="(SELECT * FROM sales_channel WHERE channel_state = '1') sales_channel,channel_name,id" placeholder="请选择订单渠道"/>
        </a-form-item>
        
      </a-form>
    </a-spin>
    <a-button type="primary" @click="handleOk">确定</a-button>
    <a-button type="primary" @click="handleCancel">取消</a-button>
  </a-drawer>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JDate from '@/components/jeecg/JDate'  
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  
  export default {
    name: "SalesOrderModal",
    components: { 
      JDate,
      JDictSelectTag,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/sales/salesOrder/add",
          edit: "/sales/salesOrder/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'orderCode','channelOrderCode','isDelivery','deliveryAddress','consumerName','consumerPhone','orderCreatetime','orderPaytime','orderTotalprice','orderOriginalprice','orderUserprice','orderDeliveryprice','isOnsale','salePrice','saleContext','isCoupon','couponPrice','couponName','orderStoreid','orderStorecontact','orderStoreowner','orderState','relPublishids','orderChanner'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'orderCode','channelOrderCode','isDelivery','deliveryAddress','consumerName','consumerPhone','orderCreatetime','orderPaytime','orderTotalprice','orderOriginalprice','orderUserprice','orderDeliveryprice','isOnsale','salePrice','saleContext','isCoupon','couponPrice','couponName','orderStoreid','orderStorecontact','orderStoreowner','orderState','relPublishids','orderChanner'))
      }
      
    }
  }
</script>

<style lang="less" scoped>
/** Button按钮间距 */
  .ant-btn {
    margin-left: 30px;
    margin-bottom: 30px;
    float: right;
  }
</style>